import React from 'react';

import { Grid } from '@mui/material';
import { InAutocompleteWrapper } from './InAutocompleteWrapper';
import CommonFilter from './CommonFilter';

import { FiltroConstants } from '@datatox-bi/util';

export const TextFilter = ({ cubo, metaAtributoSelected, disabled, filtro, onChangeFilter, preFiltros, preFiltrosServer }) => {
    let filter;
    switch (filtro.tipoComponente) {
        case FiltroConstants.TIPO_FILTRO.IN_SELECT:
            filter = (
                <InAutocompleteWrapper
                    cubo={cubo}
                    metaAtributoSelected={metaAtributoSelected}
                    onChangeFilter={onChangeFilter}
                    filtro={filtro}
                    preFiltros={preFiltros}
                    multiple={filtro.multiple}
                    preFiltrosServer={preFiltrosServer}
                />
            );
            break;
        case FiltroConstants.TIPO_FILTRO.EQUAL:
        case FiltroConstants.TIPO_FILTRO.NOT_EQUAL:
        case '':
            filter = (
                <Grid item xs={12} sm={12} md={12}>
                    <CommonFilter filtro={filtro} onChangeFilter={onChangeFilter} disabled={disabled} />
                </Grid>
            );
            break;
        default:
            filter = <></>;
    }

    return <>{filter}</>;
};
